<template>
  <div class="signup-container">
    <div class="signup-card">
      <div class="signup-header">
        <div class="signup-icon">
          <i class="fas fa-user-plus"></i>
        </div>
        <h2 class="signup-title">Регистрация</h2>
        <p class="signup-subtitle">Создайте аккаунт для начала работы</p>
      </div>
      
      <form @submit.prevent="registerUser" class="signup-form">
      <div class="mb-3">
        <label for="id_user_type" class="form-label form-label-modern">Тип пользователя:</label>
        <select v-model="userType" class="form-select form-select-modern" id="id_user_type" required>
          <option value="individual">Частное лицо</option>
          <option value="organization">Организация</option>
        </select>
      </div>

      <div class="mb-3">
        <label for="id_last_name" class="form-label form-label-modern">Фамилия:</label>
        <input
          type="text"
          v-model="lastName"
          class="form-control form-control-modern"
          id="id_last_name"
          required
          placeholder="Иванов"
          autocomplete="family-name"
        >
      </div>

      <div class="mb-3">
        <label for="id_first_name" class="form-label form-label-modern">Имя:</label>
        <input
          type="text"
          v-model="firstName"
          class="form-control form-control-modern"
          id="id_first_name"
          required
          placeholder="Иван"
          autocomplete="given-name"
        >
      </div>

      <div class="mb-3">
        <label for="id_patronymic" class="form-label form-label-modern">Отчество:</label>
        <input
          type="text"
          v-model="patronymic"
          class="form-control form-control-modern"
          id="id_patronymic"
          placeholder="Иванович"
          autocomplete="additional-name"
        >
      </div>

      <div class="mb-3">
        <label for="id_email" class="form-label form-label-modern">Электронная почта:</label>
        <input 
          type="email" 
          v-model="email" 
          class="form-control form-control-modern" 
          id="id_email" 
          required 
          placeholder="name@example.com"
          autocomplete="email"
        >
      </div>

      <div class="mb-3">
        <label for="id_position" class="form-label form-label-modern">Должность:</label>
        <input
          type="text"
          v-model="position"
          class="form-control form-control-modern"
          id="id_position"
          required
          placeholder="Врач-радиолог"
          autocomplete="organization-title"
        >
      </div>

      <div v-if="userType === 'individual'" class="mb-3">
        <label for="id_workplace" class="form-label form-label-modern">Место работы:</label>
        <input
          type="text"
          v-model="workplace"
          class="form-control form-control-modern"
          id="id_workplace"
          required
          placeholder="Клиника, НИИ, больница"
          autocomplete="organization"
        >
      </div>

      <div v-if="userType === 'organization'" class="mb-3">
        <label for="id_organization_name" class="form-label form-label-modern">Название организации:</label>
        <input 
          type="text" 
          v-model="organizationName" 
          class="form-control form-control-modern" 
          id="id_organization_name" 
          required 
          placeholder="Название организации"
        >
      </div>

      <div v-if="userType === 'organization'" class="mb-3">
        <label for="id_contact_person" class="form-label form-label-modern">Контактное лицо:</label>
        <input 
          type="text" 
          v-model="contactPerson" 
          class="form-control form-control-modern" 
          id="id_contact_person" 
          required 
          placeholder="Имя контактного лица"
        >
      </div>
      
      <div class="mb-3">
        <label for="id_username" class="form-label form-label-modern">Имя пользователя:</label>
        <input 
          type="text" 
          v-model="username" 
          class="form-control form-control-modern" 
          id="id_username" 
          required 
          placeholder="Имя для входа"
          autocomplete="username"
        >
        <small class="form-text text-muted">
          До 150 символов: буквы, цифры и символы @ . + - _
        </small>
      </div>

      <div class="mb-3">
        <label for="id_password1" class="form-label form-label-modern">Пароль:</label>
        <input 
          type="password" 
          v-model="password1" 
          class="form-control form-control-modern" 
          id="id_password1" 
          required 
          placeholder="Придумайте пароль"
          autocomplete="new-password"
        >
        <ul class="form-text text-muted">
          <li>Не короче 8 символов.</li>
          <li>Не похож на имя пользователя или почту.</li>
          <li>Не из списка слишком простых паролей.</li>
          <li>Не состоит только из цифр.</li>
        </ul>
      </div>

      <div class="mb-3">
        <label for="id_password2" class="form-label form-label-modern">Подтверждение пароля:</label>
        <input 
          type="password" 
          v-model="password2" 
          class="form-control form-control-modern" 
          id="id_password2" 
          required 
          placeholder="Повторите пароль"
          autocomplete="new-password"
        >
        <small class="form-text text-muted">
          Введите тот же пароль ещё раз.
        </small>
      </div>

        <button type="submit" class="btn btn-primary-modern signup-form__submit" :disabled="isLoading">
          <span v-if="!isLoading">
            <i class="fas fa-user-plus me-2"></i>
            Зарегистрироваться
          </span>
          <span v-else>
            <span class="spinner-border spinner-border-sm spinner-border-brand me-2" role="status"></span>
            Регистрация...
          </span>
        </button>
      </form>
    </div>
  </div>

  <!-- Loading overlay -->
  <LoadingOverlay :is-loading="isLoading" />

  <!-- Error pop-up -->
  <PopUp v-if="showErrorPopup" :message="errorMessage" :isVisible="showErrorPopup" @close="showErrorPopup = false" />
</template>

<script>
import { useUserStore } from '../stores/userStore';
import { apiErrorMessage } from '../api/errors';
import { AUTH_SIGNUP_FAILED } from '@/constants/userMessages';
import { signup } from '../api/modules/userApi';
import LoadingOverlay from './LoadingOverlay.vue';
import PopUp from './PopUp.vue';

export default {
  components: {
    LoadingOverlay,
    PopUp
  },
  data() {
    return {
      email: '',
      username: '',
      lastName: '',
      firstName: '',
      patronymic: '',
      position: '',
      workplace: '',
      password1: '',
      password2: '',
      userType: 'individual',
      organizationName: '',
      contactPerson: '',
      isLoading: false,
      showErrorPopup: false,
      errorMessage: ''
    };
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  methods: {
    async registerUser() {
      if (this.password1 !== this.password2) {
        this.showError('Пароли не совпадают.');
        return;
      }

      this.isLoading = true;
      try {
        const userData = {
          email: this.email,
          username: this.username,
          password: this.password1,
          user_type: this.userType,
          last_name: this.lastName,
          first_name: this.firstName,
          patronymic: this.patronymic,
          position: this.position,
        };

        if (this.userType === 'organization') {
          userData.organization_name = this.organizationName;
          userData.contact_person = this.contactPerson;
        } else {
          userData.workplace = this.workplace;
        }

        const data = await signup(userData);
        const { access, refresh, user } = data;
        this.userStore.setTokens(access, refresh);
        this.userStore.setUser(user);
        this.$router.push(Number(user?.role) === 0 ? '/pending' : '/');
      } catch (error) {
        this.showError(apiErrorMessage(error, AUTH_SIGNUP_FAILED));
      } finally {
        this.isLoading = false;
      }
    },
    showError(message) {
      this.errorMessage = message;
      this.showErrorPopup = true;
    }
  }
};
</script>

<style scoped>
.signup-container {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--tcp-gradient-hero-bg);
}

.signup-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  padding: 3rem;
  width: 100%;
  max-width: 550px;
  animation: slideUp 0.5s ease-out;
}

.signup-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.signup-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background: var(--tcp-gradient-brand);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: white;
  box-shadow: var(--tcp-shadow-brand-lg);
}

.signup-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--tcp-color-text-heading);
  margin-bottom: 0.5rem;
}

.signup-subtitle {
  color: var(--tcp-color-text-slate);
  font-size: 1rem;
  margin: 0;
}

.signup-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.signup-form .mb-3 {
  margin-bottom: 0;
}

.signup-form .form-text {
  font-size: 0.875rem;
  color: var(--tcp-color-text-slate);
  margin-top: 0.5rem;
}

ul.form-text {
  padding-left: 20px;
  margin-top: 0.5rem;
}

ul.form-text li {
  margin-bottom: 0.25rem;
}

.signup-form__submit {
  width: 100%;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  margin-top: 1rem;
}

.signup-form__submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 576px) {
  .signup-card {
    padding: 2rem 1.5rem;
  }
  
  .signup-title {
    font-size: 1.75rem;
  }
}
</style>